import AddNewButton from "../../atoms/Buttons/AddNewButton";
import SectionTitle from "../SectionTitle";

const SectionContainer = (props) => {
  const {
    sectionNameClass = "col-lg-7 text-left commonTitleText",
    sectionTitle,
    sectionDescription,
    hasSectionButton,
    addNewButtonClassName,
    addNewButtonName,
    href,
    btnType,
    onButtonClick,
    isVisible,
    setIsVisible,
    setShowLoader,
  } = props;
  return (
    <div className="row title-wrap">
      <SectionTitle
        sectionNameClass={sectionNameClass}
        sectionTitle={sectionTitle}
        sectionDescription={sectionDescription}
      />
      {hasSectionButton && (
        <div className="col-lg-5 text-right">
          <AddNewButton
            addNewButtonClassName={addNewButtonClassName}
            addNewButtonName={addNewButtonName}
            href={href}
            btnType={btnType}
            onClick={onButtonClick}
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            setShowLoader={setShowLoader}
          />
        </div>
      )}
    </div>
  );
};

export default SectionContainer;
